<template>
    <div>
        <NavBar @activeSidebar="toggleDrawerBar" style="position: fixed;z-index: 99;width: 100%;" />
        <v-navigation-drawer
            v-model="drawerBar"
            :permanent="!$vuetify.breakpoint.smAndDown"
            :temporary="$vuetify.breakpoint.smAndDown"
            app
            :clipped="$vuetify.breakpoint.smAndDown"
            style="z-index: 5; background: linear-gradient(135deg, #005dbe, #0062be, #005dc6) !important; color: white !important;"
        >
            <Sidebar :itemsMenu="itemsMenu" />
        </v-navigation-drawer>
        <div class="main-responsive" :style="mainResponsiveStyle">
            <router-view></router-view>
        </div>
        <v-overlay :z-index="zIndex" :value="overlay">
            <v-card elevation="2" shaped class="mx-auto my-5 elevation-1">
                <v-row class="fill-height">
                    <v-col>
                        Usuario Inhabilitado
                    </v-col>
                </v-row>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
import NavBar from "../../../components/navbar/NavBar.vue";
import Sidebar from "../../../components/sidebar/sidebar.vue";
import { mapState, mapActions } from "vuex";
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export const API_KEY_DNI = process.env.VUE_API_KEY_DNI;

export default {
    data() {
        return {
            overlay: false,
            zIndex: 99,
            perfil: "",
            nombre: "",
            itemsMenu: [],
            idUsuario: null,
            system: "Laboratorio Examenes",
            idSystem: null,
            drawerBar: !this.$vuetify.breakpoint.smAndDown // Abierto en desktop, cerrado en móvil
        };
    },
    methods: {
        toggleDrawerBar() {
            this.drawerBar = !this.drawerBar;
        },
        getIdSytem() {
            axios
                .get(RUTA_API + "/seguridad_system/obtener-id/?system=" + this.system)
                .then((res) => {
                    this.idSystem = res.data[0].id;
                    sessionStorage.setItem("idSystem", this.idSystem);
                    this.loadComponentes();
                })
                .catch((res) => {});
        },
        loadComponentes() {
            axios
                .get(RUTA_API + "/seguridad_usuario/buscar-usuario/?usuario=" + this.idUsuario + "&system=" + this.idSystem)
                .then((res) => {
                    if (res.data.estado == false) {
                        this.overlay = true;
                    }
                    const lista = res.data[0].componentes;
                    this.itemsMenu = this.estructurarComponentes(lista);
                    sessionStorage.setItem("correoAuditorioUsuario", res.data.correo);
                    sessionStorage.setItem("idUsuarioAuditorio", res.data.id);
                    sessionStorage.setItem("usuarioArea", res.data.area);
                })
                .catch((res) => {});
        },
        estructurarComponentes(lista) {
            const mapa = {}; // Almacena los elementos por su ID
            const resultado = []; // Lista final con estructura jerárquica
            lista.forEach(item => {
                mapa[item.id] = { ...item, children: [] };
            });
            lista.forEach(item => {
                if (item.padre_id === 0) {
                    resultado.push(mapa[item.id]);
                } else if (mapa[item.padre_id]) {
                    mapa[item.padre_id].children.push(mapa[item.id]);
                }
            });
            function limpiarHijos(obj) {
                if (obj.children.length === 0) {
                    delete obj.children;
                } else {
                    obj.children.forEach(limpiarHijos);
                }
            }
            resultado.forEach(limpiarHijos);
            return resultado;
        },
        ...mapActions(["setDrawerBar"]),
    },
    computed: {
        ...mapState(["drawerBar"]),
        mainResponsiveStyle() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return 'width: 100%; padding: 1.5rem; margin-top: 4rem; background: #f8f8fb !important;';
            } else {
                return 'width: 100%; padding-left: 1.5rem; padding-right: 1.5rem; margin-top: 3rem; background: #f8f8fb !important;';
            }
        }
    },
    watch: {
        '$vuetify.breakpoint.smAndDown'(val) {
            this.drawerBar = !val; // Si es móvil, cerrado; si es desktop, abierto
        }
    },
    mounted() {
        this.getIdSytem();
    },
    created() {
        this.perfil = sessionStorage.getItem("perfil");
        this.nombre = sessionStorage.getItem("nombre");
        this.idUsuario = sessionStorage.getItem("idUsuario");
        this.$router.afterEach(() => {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.drawerBar = false;
            }
        });
    },
    components: {
        NavBar,
        Sidebar
    },
};
</script>

<style scoped>
.v-navigation-drawer {
    width: 280px !important;
    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.618);
}

.main-responsive {
    transition: padding-left 0.3s;
}

@media (max-width: 1024px) {
    .main-responsive {
        margin-left: 0rem !important;
        padding-left: 1.5rem;
    }
}

@media (min-width: 1024px) {
    .main-responsive {
        padding-left: 22rem;
    }
}

/* Resto de tus estilos... */
</style>